import * as React from "react";
import useAuth from "../hooks/useAuth";
import OutButton from "./pieces/OutButton";
const AuthModal = React.lazy(() => import("./pieces/AuthModal"));
const Sections = React.lazy(() => import("./sections/Sections"));

const MainPanel = React.memo(function MainPanel() {
	const [user, handleAuth, handleLogout] = useAuth();
	return (
		<>
			{!user ? (
				<AuthModal open={!user} handleAuth={handleAuth} />
			) : (
				<>
					<Sections />
					<OutButton {...{ handleLogout }} />
				</>
			)}
		</>
	);
});

export default MainPanel;
